import React from "react";
import "./App.css";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import DialogBox from "./components/DialogBox";
import { locale } from "./utils/LocaleManager";
import { useAuthStore } from "./stores/authStore";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { router } from "./utils/Routes";
import { theme } from "./utils/StyleHelpers";
import RolePermissions from "./components/RolePermissions";
import TokenRefresh from "./components/TokenRefresh";
import { ToastContainer } from "react-toastify";

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    custom: true;
  }
}

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: `${process.env.REACT_APP_CLIENT_ID}`,
    authority: `${process.env.REACT_APP_AUTHORITY_URL}`,
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "localStorage",
  },
});

function App() {
  console.log(
    "STAVC APP VERSION",
    `${process.env.REACT_APP_VERSION ?? "1.0.10"}`,
  );
  const setIsShowLogoutModal = useAuthStore(
    (state: any) => state.setIsShowLogoutModal,
  );
  const isShowLogoutModal = useAuthStore(
    (state: any) => state.isShowLogoutModal,
  );

  return (
    <ThemeProvider theme={theme}>
      <MsalProvider instance={msalInstance}>
        <TokenRefresh></TokenRefresh>
        <RolePermissions></RolePermissions>
        <RouterProvider router={router} />
        {isShowLogoutModal && (
          <DialogBox
            header={locale.logoutHeader}
            body={locale.logoutBody}
            onCancel={() => {
              setIsShowLogoutModal(false);
            }}
            onSubmit={() => {
              msalInstance.logout();
            }}
            subBody=""
            isDelete={false}
            primaryButton={locale.yes}
            secondaryButton={locale.no}
          ></DialogBox>
        )}
      </MsalProvider>
      <ToastContainer closeButton={false} />
    </ThemeProvider>
  );
}

export default App;
